import * as actions from '../actions/brokerFirms';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';

export function requestBrokerFirmsWithAgents(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_BROKER_FIRMS_WITH_AGENTS)
        .map(action => ({
            url: BASE_URL + 'api/users/GetBrokerFirmsWithAgents',
            category: 'requestBrokerFirmsWithAgents',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestBrokerFirmsWithAgents')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getBrokerFirmsWithAgentsSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestBrokerFirmsWithAgentsFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestBrokerFirmsWithAgents')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !==200)
        .map(response => actions.getBrokerFirmsWithAgentsFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function requestBrokerFirms(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_BROKER_FIRMS)
        .map(action => ({
            url: BASE_URL + 'api/users/GetBrokerFirms',
            category: 'requestBrokerFirms',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestBrokerFirms')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getBrokerFirmsSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function requestBrokerFirmsFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestBrokerFirms')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !==200)
        .map(response => actions.getBrokerFirmsFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function getBrokerFirmsPostcodes(sources) {

    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_BROKER_FIRMS_POSTCODES)
        .map(action => ({
            url: BASE_URL + 'api/users/GetBrokerFirmsPostcodes',
            category: 'getBrokerFirmsPostcodes',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('getBrokerFirmsPostcodes')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.getBrokerFirmsPostcodesSuccess(response));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function getBrokerFirmsPostcodesFailed(sources) {
    let httpResponse$ = sources.HTTP
        .select('getBrokerFirmsPostcodes')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !==200)
        .map(response => actions.getBrokerFirmsPostcodesFailed(response));

    return {
        ACTION: httpResponse$
    };
}

export function getBrokerFirmsFiltered(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_BROKER_FIRMS_FILTERED)
		.map(action => ({
			url: BASE_URL + 'api/users/GetBrokerFirmsWithAgentsFiltered?' + (action.payload.search?`search=${action.payload.search}`:'') ,
			category: 'getBrokerFirmsFiltered',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	//below httpResponse$ listens  for http responses and after filtering ,in order to get
	//the successful http get requests, it updates the redux store with the lawsys agents
	let httpResponse$ = sources.HTTP
		.select('getBrokerFirmsFiltered')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveBrokerFirmsFiltered(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function failedgetBrokerFirmsFiltered(sources) {
	let httpResponse$ = sources.HTTP
		.select('getBrokerFirmsFiltered')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.receiveBrokerFirmsFiltered([]));

	return {
		ACTION: httpResponse$
	}
}